import client, { setCsrfToken } from './client';
export async function login(email, password) {
  // Another tab can rotate the CSRF cookie by signing in. Never reuse the
  // token cached before that login, including after a failed attempt.
  const { data } = await client.get('/v1/auth/csrf/');
  setCsrfToken(data.csrfToken);
  const response = await client.post('/v1/auth/login/', { email, password });
  setCsrfToken(response.data.csrfToken);
  return response;
}
export async function logout() {
  await client.post('/v1/auth/logout/');
  setCsrfToken(null);
}
// Niente registrazione pubblica: si entra con un link di invito, e lo stesso
// link serve per reimpostare la password.
export const getInvitation = token => client.get(`/v1/auth/invitations/${encodeURIComponent(token)}/`);
export async function acceptInvitation(token, password, passwordConfirm) {
  const { data } = await client.get('/v1/auth/csrf/');
  setCsrfToken(data.csrfToken);
  const response = await client.post('/v1/auth/invitations/accept/',
    { token, password, password_confirm: passwordConfirm });
  setCsrfToken(response.data.csrfToken);
  return response;
}
export const getMe = () => client.get('/v1/auth/me/');
